import Delegate from "//legramme.com/cdn/shop/t/76/assets/ftdomdelegate.min.js?v=167457923630348017651764174054";

export class GiftCardProductSection extends HTMLElement {
  connectedCallback() {
    this.allTabs = this.querySelectorAll('[data-action="change-tab"]');
    this.allProductsTabs = this.querySelectorAll('[data-action="products-tab"]');

    this._attachListeners();

    // open good tab
    this._changeTabPrice();
  }

  _attachListeners() {
    new Delegate(this).on('click', '[data-action="change-tab"]', this._changeTab.bind(this));

    document.addEventListener('variant:changed', (event) => {
      this._changeTabPrice();
    });
  }

  _changeTab(event, target) {
    if (event) event.preventDefault();

    if (this.allTabs && this.allProductsTabs) {
      for (let i = 0; i < this.allTabs.length; i++) {
        this.allTabs[i].classList.remove('active');
        this.allProductsTabs[i].classList.remove('active');
      }
    }

    target.classList.add('active');
    this.querySelector('[data-action="products-tab"][data-tab="' + target.getAttribute('data-tab') + '"]').classList.add('active');
  }

  _changeTabPrice() {
    let that = this;
    setTimeout(function () {
      let index = $('#product-form-' + window.theme.giftCardProductId + ' option:selected').index();
      that._changeTab('', that.querySelectorAll('.featured-products-section__tab')[index]);
    }, 0)

  }

}
try {
  window.customElements.define('product-section', GiftCardProductSection);
} catch (e) { }  